var render = function render(){var _vm=this,_c=_vm._self._c;return _c('donut-chart34-template',{attrs:{"board-ids":[114, 234, 235, 236, 237],"data-type":_vm.dataType,"field-code":"public-transportation","graph-id":72,"title":"(공중교통수단) 관리 현황","unit":"건","orientation":_vm.orientation}})
}
var staticRenderFns = []

export { render, staticRenderFns }